export default "__VITE_ASSET__df723100__"